/* src/app/components/payroll/authorizations/auth-additional-details/auth-additional-details.component.css */
/*# sourceMappingURL=auth-additional-details.component-RGGKMY4W.css.map */
